<form class="high-school-form" [formGroup]="highSchoolForm" (ngSubmit)="onSubmit()">
  <div class="form-row">
    <div class="form-group">
      <app-input
        id="schoolName"
        formControlName="schoolName"
        [label]="'profile.highSchool.schoolName' | transloco"
        [placeholder]="'profile.highSchool.enterSchoolName' | transloco"
        [required]="true"
        [errorMessage]="
          highSchoolForm.get('schoolName')?.invalid && highSchoolForm.get('schoolName')?.touched ?
          (highSchoolForm.get('schoolName')?.errors?.['required'] ?
          ('validation.required.highSchoolName' | transloco) :
          highSchoolForm.get('schoolName')?.errors?.['maxlength'] ?
          ('validation.databaseConstraint.highSchoolName' | transloco: {max: VALIDATION.HIGH_SCHOOL_NAME_MAX_LENGTH}) :
          '') : ''
        "></app-input>
    </div>
    <div class="form-group">
      <app-input
        id="fieldOfStudy"
        formControlName="fieldOfStudy"
        [label]="'profile.highSchool.fieldOfStudy' | transloco"
        [placeholder]="'profile.highSchool.enterFieldOfStudy' | transloco"
        [required]="true"
        [errorMessage]="
          highSchoolForm.get('fieldOfStudy')?.invalid && highSchoolForm.get('fieldOfStudy')?.touched ?
          (highSchoolForm.get('fieldOfStudy')?.errors?.['required'] ?
          ('validation.required.fieldOfStudy' | transloco) :
          highSchoolForm.get('fieldOfStudy')?.errors?.['maxlength'] ?
          ('validation.databaseConstraint.fieldOfStudy' | transloco: {max: VALIDATION.FIELD_OF_STUDY_MAX_LENGTH}) :
          '') : ''
        "></app-input>
    </div>
  </div>

  <div class="form-row">
    <div class="form-group">
      <app-select
        id="educationLevelID"
        formControlName="educationLevelID"
        [label]="'profile.highSchool.educationLevel' | transloco"
        [placeholder]="'profile.highSchool.selectEducationLevel' | transloco"
        [options]="educationLevelOptions"
        [required]="true"
        [errorMessage]="highSchoolForm.get('educationLevelID')?.invalid && highSchoolForm.get('educationLevelID')?.touched ? ('validation.required.educationLevel' | transloco) : ''">
      </app-select>
    </div>
  </div>

  <div class="form-row">
    <div class="form-group">
      <app-input
        id="city"
        formControlName="city"
        [label]="'profile.highSchool.city' | transloco"
        [placeholder]="'profile.highSchool.enterCity' | transloco"
        [errorMessage]="
          highSchoolForm.get('city')?.invalid && highSchoolForm.get('city')?.touched ?
          ('validation.maxLength.city' | transloco: {max: VALIDATION.CITY_MAX_LENGTH}) : ''
        "></app-input>
    </div>
    <div class="form-group">
      <app-input
        id="country"
        formControlName="country"
        [label]="'profile.highSchool.country' | transloco"
        [placeholder]="'profile.highSchool.enterCountry' | transloco"
        [errorMessage]="
          highSchoolForm.get('country')?.invalid && highSchoolForm.get('country')?.touched ?
          ('validation.maxLength.country' | transloco: {max: VALIDATION.COUNTRY_MAX_LENGTH}) : ''
        "></app-input>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group">
      <app-input
        id="startDate"
        formControlName="startDate"
        type="date"
        [label]="'profile.highSchool.startDate' | transloco"
        [placeholder]="'profile.highSchool.enterStartDate' | transloco"
        [required]="true"
        [errorMessage]="highSchoolForm.get('startDate')?.invalid && highSchoolForm.get('startDate')?.touched ? ('validation.required.startDate' | transloco) : ''"></app-input>
    </div>
    <div class="form-group">
      <app-input
        id="endDate"
        formControlName="endDate"
        type="date"
        [label]="'profile.highSchool.endDate' | transloco"
        [placeholder]="'profile.highSchool.enterEndDate' | transloco"
        [required]="true"
        [errorMessage]="highSchoolForm.get('endDate')?.invalid && highSchoolForm.get('endDate')?.touched ? ('validation.required.endDate' | transloco) : (highSchoolForm.errors?.['dateRange'] && highSchoolForm.get('endDate')?.touched ? ('profile.validation.endBeforeStart' | transloco) : '')"></app-input>
    </div>
  </div>

  <!-- Certificate Upload Section -->
  <div class="form-row">
    <div class="form-group full-width">
      <label class="file-upload-label">{{ 'profile.highSchool.documents' | transloco }}</label>
      <div class="file-dropzone" [class.has-file]="attachment.fileName">
        <div class="file-dropzone__upload-area" *ngIf="!attachment.fileName">
          <div class="file-dropzone__icon">
            <i class="fas fa-file-upload"></i>
          </div>
          <div class="file-dropzone__text">
            <p>{{ 'profile.highSchool.dragDropDocuments' | transloco }}</p>
            <span>{{ 'profile.resume.or' | transloco }}</span>
          </div>
          <app-button type="button" size="md" variant="outline" color="secondary" (click)="fileInput.click()">
            {{ 'profile.resume.browse' | transloco }}
          </app-button>
          <p class="file-dropzone__info">{{ 'profile.resume.supportedFormats' | transloco }}</p>
          <input type="file" hidden #fileInput (change)="onFileChange($event)" accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" />
        </div>

        <div class="file-dropzone__file-info" [class.hidden]="!attachment.fileName">
          <div class="file-dropzone__file-icon">
            <i class="fas fa-file-pdf"></i>
          </div>
          <div class="file-dropzone__file-details">
            <div class="file-dropzone__file-name">{{ attachment.fileName }}</div>
            <div class="file-dropzone__file-size">{{ attachment.fileSize }}</div>
          </div>
          <app-button type="button" variant="outline" color="secondary" (click)="removeFile()">
            <i class="fas fa-times"></i>
          </app-button>
        </div>

        <!-- Loading indicator -->
        <div class="file-dropzone__loading" *ngIf="isUploading">
          <div class="spinner"></div>
          <p>{{ 'profile.highSchool.uploading' | transloco }}</p>
        </div>
        
        <!-- Error message -->
        <div class="file-dropzone__error" *ngIf="fileError">
          <div class="file-dropzone__error-icon">
            <i class="fas fa-exclamation-circle"></i>
          </div>
          <p class="file-dropzone__error-message">{{ fileError }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="form-actions">
    <app-button type="button" variant="outline" color="secondary" (click)="cancel.emit()">
      {{ 'button.cancel' | transloco }}
    </app-button>
    <app-button type="submit" variant="filled" [disabled]="highSchoolForm.invalid || isUploading">
      {{ 'button.save' | transloco }}
    </app-button>
  </div>
</form>
